import { getFirestore } from "firebase/firestore";
import app from "./firebaseApp";

const firestoreInstance = getFirestore(app);

export default firestoreInstance;
